/* eslint-disable */
import React from 'react';
import { CustomPicker } from 'react-color';
import { EditableInput, Saturation, Hue } from 'react-color/lib/components/common';
import { isValidHex } from 'react-color/lib/helpers/color';
import Pointer from './Pointer';
import Color from './Color';

class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleChange(data) {
        this.props.onChange(data);
    }

    handleInputChange(data) {
        // data is an object including the label of the input as key, and the value as its value
        if (data.hex && isValidHex(data.hex)) {
            this.props.onChange(data.hex);
        } else if (data.r || data.g || data.b) {
            this.props.onChange({
                r: data.r || this.props.rgb.r,
                g: data.g || this.props.rgb.g,
                b: data.b || this.props.rgb.b,
                a: this.props.rgb.a,
            });
        } else if (data.a) {
            if (data.a < 0) {
                data.a = 0;
            } else if (data.a > 100) {
                data.a = 100;
            }

            data.a = data.a / 100;
            this.props.onChange({
                h: this.props.hsl.h,
                s: this.props.hsl.s,
                l: this.props.hsl.l,
                a: data.a,
            });
        }
    }

    renderColor(color, index) {
        const classes = ['menu__item'];
        let key = `color-${index}`;

        return (
            <li className={classes.join(' ')} key={key} onClick={() => this.handleChange(color)}>
                <Color color={color} isCustomColor={true} />
            </li>
        );
    }

    render() {
        const { rgb, hex, previousColor, customColors } = this.props;
        const prevBg = {
            backgroundColor: `rgb(${previousColor.r},${previousColor.g},${previousColor.b})`,
        };
        const newBg = {
            backgroundColor: `rgb(${rgb.r},${rgb.g},${rgb.b})`,
        };
        return (
            <div className="color-picker">
                {customColors.length >= 1 ? (
                    <ul className="menu color-swatches">
                        {customColors.map((color, index) => this.renderColor(color, index, true))}
                    </ul>
                ) : null}
                <div className="color-picker__saturation">
                    <Saturation {...this.props} pointer={Pointer} onChange={this.handleChange} />
                </div>
                <div className="color-picker__controls">
                    {customColors.length >= 1 ? (
                        <ul className="menu color-swatches">
                            {customColors.map((color, index) =>
                                this.renderColor(color, index, true)
                            )}
                        </ul>
                    ) : null}
                    <div className="color-picker__hue">
                        <Hue
                            {...this.props}
                            onChange={this.handleChange}
                            pointer={Pointer}
                            direction="horizontal"
                        />
                    </div>
                    <div className="color-picker__inputs">
                        <div className="color-picker__input color-picker__input--hex">
                            <EditableInput
                                value={hex}
                                label="hex"
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="color-picker__input color-picker__input--rgb">
                            <EditableInput
                                value={this.props.rgb.r}
                                label="r"
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="color-picker__input color-picker__input--rgb">
                            <EditableInput
                                value={this.props.rgb.g}
                                label="g"
                                onChange={this.handleInputChange}
                            />
                        </div>
                        <div className="color-picker__input color-picker__input--rgb">
                            <EditableInput
                                value={this.props.rgb.b}
                                label="b"
                                onChange={this.handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="color-picker__previous-new">
                        <div className="previous" style={prevBg} />
                        <div className="new" style={newBg} />
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomPicker(ColorPicker);
